module.exports = __webpack_public_path__ + "static/img/loading.091b57b.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/common/loading.gif
// module id = /9Hc
// module chunks = 1